import * as React from "react";
import { Card } from "semantic-ui-react";

import { BookAppointmentTaskListModel } from "../models";

import { BookAppointmentCard } from "./BookAppointmentCard";

interface Props {
    bookAppointmentTasks: BookAppointmentTaskListModel[];
    onChooseAndBook: (task: BookAppointmentTaskListModel) => void;
}

export const BookAppointmentsCards = ({ bookAppointmentTasks, onChooseAndBook }: Props) => {
    return (
        <Card.Group className="cards">
            <div>{`Total Appointments: ${bookAppointmentTasks.length}`}</div>
            {bookAppointmentTasks.map((bookTask) => (
                <BookAppointmentCard key={bookTask.id} task={bookTask} onChooseAndBook={onChooseAndBook} />
            ))}
        </Card.Group>
    );
};
